import _find from 'lodash/find';
import './dashboard-header.scss';
import template from './dashboard-header.html';

class DashboardHeaderComponent {
  /** @ngInject */
  constructor(
    $log, $state,
    SchoolCommonRoomService,
    ClassRoomService
  ) {
    this.$log = $log;
    this.$state = $state;
    this.SchoolCommonRoomService = SchoolCommonRoomService;
    this.ClassRoomService = ClassRoomService;

    this.schoolCommonRooms = [];
    this.date = new Date();
  }

  $onInit() {
    this.ClassRoomService.getClassRooms().then(result => {
      this.classRooms = result;
      this.selectedClassRoom = _find(this.classRooms, classRoom => classRoom.id === this.selected.id);
    });
  }

  $onChanges(changes) {
    if (changes.selected) {
      this.selected = {...this.selected};
    }
  }

  changeClassRoom(classRoom) {
    this.ClassRoomService.setCurrentClassRoom(classRoom);
    this.$state.reload();
  }
}

export const DashboardHeader = {
  bindings: {
    selected: '<'
  },
  template,
  controller: DashboardHeaderComponent
};
